var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78904 9.58453C6.80134 11.1765 3.89177 11.0512 2.04918 9.20863C0.0721489 7.2316 0.0721489 4.02621 2.04918 2.04918C4.02621 0.0721488 7.23161 0.0721492 9.20863 2.04918C11.0512 3.89176 11.1765 6.80133 9.58454 8.78903L13.4513 12.6558C13.6709 12.8754 13.6709 13.2316 13.4513 13.4513C13.2316 13.6709 12.8754 13.6709 12.6558 13.4513L8.78904 9.58453ZM2.84467 8.41314C1.30698 6.87545 1.30698 4.38236 2.84467 2.84467C4.38236 1.30698 6.87545 1.30698 8.41314 2.84467C9.9497 4.38123 9.95083 6.87179 8.41652 8.40975C8.41539 8.41087 8.41426 8.41199 8.41313 8.41312C8.412 8.41425 8.41087 8.41538 8.40976 8.41652C6.8718 9.95083 4.38124 9.9497 2.84467 8.41314Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.50395888d7a7a4d6f47584ce5534807e.svg";
export { ForwardRef as ReactComponent };